import { timelineEvents } from "../../../mocks/trendData";

export default function Record() {
  return (
    <section id="record" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
              <i className="ri-history-line" aria-hidden="true"></i> 事件全记录
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              近期热点 · 全记录档案
            </h2>
            <p className="mt-2 text-sm text-foreground-500 md:text-base">
              按时间倒序持续收录，每个话题都能翻到最原始的走向。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {timelineEvents.map((ev, idx) => (
            <article
              key={ev.id}
              className="group relative flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-100"
            >
              <div className="relative aspect-[16/9] w-full overflow-hidden">
                <img
                  src={ev.cover}
                  alt={ev.title}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute left-0 top-0 flex items-center gap-2 p-3">
                  <span className="grid h-9 w-9 place-items-center rounded-full bg-foreground-950/70 text-xs font-semibold text-white backdrop-blur-sm md:h-10 md:w-10">
                    {ev.date.slice(3)}
                  </span>
                </div>
                {ev.hot && (
                  <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] text-white">
                    <i className="ri-fire-fill" aria-hidden="true"></i> 高热
                  </span>
                )}
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {ev.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{ev.digest}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="font-mono text-xs text-foreground-400">{ev.date}</span>
                  <button
                    type="button"
                    className="inline-flex cursor-pointer items-center gap-1 text-xs font-medium text-primary-600 hover:text-primary-700"
                  >
                    查看记录 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}